import React, { useEffect, useState } from 'react';
import * as Styles from './Guides.styles';
import { Guide } from 'gatorcomponents';
import { isBRServer } from '@/utils/Validators/validation';
import Snappy from '@/media/billing/snappy-with-shadow.svg';
import { useSelector } from 'react-redux';
import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ENABLE_HOME_PAGE, ENABLE_LOGO_BUILDER } from '@/config/GrowthBook/constants';

const Guides = () => {
  const [alreadySawLogoBuilderGuide, setAlreadySawLogoBuilderGuide] = useState(true);
  const { template: templateLocale } = useLocale();
  const view = useResize();
  const isMobile = view.width < 960;
  const enableLogoBuilder = useFeatureIsOn(ENABLE_LOGO_BUILDER);
  const enableNewMenu = useFeatureIsOn(ENABLE_HOME_PAGE);
  const { available: logoBuilderAvailable } = useSelector(state => state.logoBuilder);

  useEffect(() => {
    const alreadySawGuide = localStorage.getItem('logoBuilderGuideIsDone');
    if (!alreadySawGuide) {
      setAlreadySawLogoBuilderGuide(false);
    }
  }, [alreadySawLogoBuilderGuide]);

  const markLogoBuilderAsRead = () => {
    localStorage.setItem('logoBuilderGuideIsDone', 'true');
    setAlreadySawLogoBuilderGuide(true);
    window.dispatchEvent(new Event('storage'));
  };

  const LogoBuilderGuideContent = () => (
    <Styles.LogoBuilderGuide>
      <Styles.GuideTexts>
        <Styles.GuideTitle data-testid="title">
          {templateLocale.logoBuilderGuide.title}
        </Styles.GuideTitle>
        <Styles.GuideDescription data-testid="description">
          {templateLocale.logoBuilderGuide.description}
        </Styles.GuideDescription>
      </Styles.GuideTexts>
      <Styles.Image src={Snappy} />
    </Styles.LogoBuilderGuide>
  );

  const logoBuilderGuideSteps = [{
    popover: {
      $left: enableNewMenu ? 211 : 195, $top: enableNewMenu ? 445 : 375, content: LogoBuilderGuideContent(), pointer: 'leftBottom', $maxwidth: 285,
    },
  }];

  if (logoBuilderAvailable && enableLogoBuilder && isBRServer && !alreadySawLogoBuilderGuide && !isMobile) {
    return (
      <>
        <Styles.GuideShadow />
        <Guide
          steps={logoBuilderGuideSteps}
          onClick={markLogoBuilderAsRead}
        />
      </>
    );
  }

  return <></>;
};

export default Guides;
